import React from 'react';
import {
  IonItem,
  IonLabel,
  IonButton,
  IonIcon,
  IonList,
  IonListHeader,
} from '@ionic/react';
import { chevronUp, chevronDown, trash } from 'ionicons/icons';

interface ReorderableListItem {
  id: string;
  displayName: string;
  description?: string;
}

interface ReorderableListProps {
  items: ReorderableListItem[];
  onReorder: (fromIndex: number, toIndex: number) => void;
  onRemove: (itemId: string) => void;
  title: string;
  emptyMessage?: string;
}

const ReorderableList: React.FC<ReorderableListProps> = ({
  items,
  onReorder,
  onRemove,
  title,
  emptyMessage = "No items"
}) => {
  const handleMoveUp = (index: number) => {
    if (index > 0) {
      onReorder(index, index - 1);
    }
  };

  const handleMoveDown = (index: number) => {
    if (index < items.length - 1) {
      onReorder(index, index + 1);
    }
  };

  if (items.length === 0) {
    return (
      <IonList style={{ margin: 0 }}>
        {title && (
          <IonListHeader>
            <IonLabel>{title}</IonLabel>
          </IonListHeader>
        )}
        <IonItem>
          <IonLabel>
            <p style={{ color: 'var(--ion-color-medium)', fontStyle: 'italic' }}>
              {emptyMessage}
            </p>
          </IonLabel>
        </IonItem>
      </IonList>
    );
  }

  return (
    <IonList style={{ margin: 0 }}>
      {title && (
        <IonListHeader>
          <IonLabel>{title}</IonLabel>
        </IonListHeader>
      )}
      
      {items.map((item, index) => (
        <IonItem key={item.id}>
          <IonLabel>
            <h3>{item.displayName}</h3>
            {item.description && <p>{item.description}</p>}
          </IonLabel>
          
          <div slot="end" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            {/* Move Up Button */}
            <IonButton
              fill="clear"
              size="small"
              onClick={() => handleMoveUp(index)}
              disabled={index === 0}
              style={{ 
                minWidth: '32px', 
                height: '32px',
                opacity: index === 0 ? 0.3 : 1
              }}
            >
              <IonIcon icon={chevronUp} />
            </IonButton>
            
            {/* Move Down Button */}
            <IonButton
              fill="clear"
              size="small"
              onClick={() => handleMoveDown(index)}
              disabled={index === items.length - 1}
              style={{ 
                minWidth: '32px', 
                height: '32px',
                opacity: index === items.length - 1 ? 0.3 : 1
              }}
            >
              <IonIcon icon={chevronDown} />
            </IonButton>
            
            {/* Remove Button */}
            <IonButton
              fill="clear"
              size="small"
              color="danger"
              onClick={() => onRemove(item.id)}
              style={{ minWidth: '32px', height: '32px' }}
            >
              <IonIcon icon={trash} />
            </IonButton>
          </div>
        </IonItem>
      ))}
    </IonList>
  );
};

export default ReorderableList;
